<template>
  <header class="app-header navbar" v-if="displayNavbar">
    <slot></slot>
  </header>
</template>
<script>
export default {
  name: 'navbar',
  created () {
    this._navbar = true
  },
  computed: {
    displayNavbar () {
      if (this.$route.query.app === null || this.$route.query.app === undefined) {
        return true
      } else if (parseInt(this.$route.query.app) === 1) {
        return false
      }
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// Navbar.vue?774f0fac